<template>
  <RouterView v-slot="{ Component }">
    <KeepAlive :include="keepAliveViews">
      <component :is="Component" />
    </KeepAlive>
  </RouterView>
  <MilestoneRouteTransition />
</template>

<script setup lang="ts">
/** Keeps Roadmap mounted while its nested project route displays a Milestone. */
import { RouterView, useRoute } from "vue-router"
import { computed } from "vue"

import MilestoneRouteTransition from "@/components/Milestone/MilestoneRouteTransition.vue"

const route = useRoute()
const cachedRouteNames = ["roadmap", "past-goals", "Milestones"]
const keepAliveViews = computed(() =>
  cachedRouteNames.includes(route.name as string) ? ["Roadmap"] : []
)
</script>
